// extracted by mini-css-extract-plugin
export var active = "_lv-2";
export var recordingDot = "_lv-1";
export var recordingIndicator = "_lv-0";